import { BookingType } from '../../redux/types/bookingTypes';
import { ExternalBooking } from '../../redux/types/integrationTypes';

export type BookingNotification =
  | { type: 'internal'; booking: BookingType }
  | { type: 'external'; booking: ExternalBooking };

export const getUnviewedBookingNotifications = (
  bookings: BookingType[] | undefined,
  externalBookings: ExternalBooking[],
): BookingNotification[] => [
  ...(bookings || [])
    .filter((booking) => !booking.viewed)
    .map((booking) => ({ type: 'internal' as const, booking })),
  ...externalBookings
    .filter((booking) => !booking.viewed)
    .map((booking) => ({ type: 'external' as const, booking })),
].sort(
  (first, second) =>
    new Date(second.booking.created_at).getTime() -
    new Date(first.booking.created_at).getTime(),
);
